// src/api/endpoints/MasterAPI.js
export class MasterAPI {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }

  getAllMasters() {
    return this.apiClient.get('/masters');
  }
  // Add more master-related methods here

  getActiveCountries() {
    return this.apiClient.request({
      url: 'api/v1/countries/active/list',
      method: 'GET',
    });
  }

  getActiveStates(countryId) {
    return this.apiClient.request({
      url: `api/v1/states/country/${countryId}`,
      method: 'GET',
    });
  }

}
